import React from "react";
import { Check, Phone, ArrowRight } from "lucide-react";
import { BUSINESS, WHY_CHOOSE } from "@/lib/constants";

export default function WhyChoose() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="miert-minket"
      data-testid="why-choose-section"
      className="velvet-navy text-[#F5F2EC] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 md:gap-16 items-start">
        <div className="md:col-span-5">
          <div className="overline mb-6 flex items-center text-[#D4B47A]">
            <span className="inline-block w-10 h-px bg-[#D4B47A] mr-4" />
            Miért minket?
          </div>
          <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05]">
            Miért minket
            <span className="italic text-[#D4B47A]"> válasszon.</span>
          </h2>
          <p className="mt-8 text-base md:text-lg text-[#F5F2EC]/80 leading-relaxed font-light max-w-md">
            A minőség, a szakértelem és a megbízhatóság nem szlogen nálunk —
            hanem a napi munkánk alapja. Minden darabot úgy kezelünk, mintha a
            saját otthonunkba készülne.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollTo("ajanlat")}
              data-testid="why-cta-quote"
              className="group inline-flex items-center justify-center gap-3 bg-[#D4B47A] text-[#0A1228] px-8 py-4 text-xs uppercase tracking-[0.25em] font-medium hover:bg-[#E5C58B] transition-all duration-300 shadow-[0_8px_30px_rgba(212,180,122,0.3)] hover:-translate-y-0.5"
            >
              Árajánlatot kérek
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </button>
            <a
              href={`tel:${BUSINESS.phoneTel}`}
              data-testid="why-cta-call"
              className="inline-flex items-center gap-2 text-[#F5F2EC] hover:text-[#D4B47A] transition-colors px-2 py-4 text-xs uppercase tracking-[0.25em] border-b border-[#F5F2EC]/25 hover:border-[#D4B47A]"
            >
              <Phone size={14} /> {BUSINESS.phoneDisplay}
            </a>
          </div>
        </div>

        <div className="md:col-span-7">
          <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-5">
            {WHY_CHOOSE.map((point, i) => (
              <li
                key={i}
                data-testid={`why-point-${i}`}
                className="flex items-start gap-4 py-3 border-b border-[#F5F2EC]/12"
              >
                <span className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#D4B47A]/15 border border-[#D4B47A]/40 flex items-center justify-center">
                  <Check size={13} className="text-[#D4B47A]" strokeWidth={2.5} />
                </span>
                <span className="text-[15px] md:text-base text-[#F5F2EC]/95 leading-snug">
                  {point}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
